/**
 * AddonsErrorBoundary — isolates the OPTIONAL add-ons (insurance / duties /
 * warehousing) on the public Confirm & book page. These reuse the portal's
 * CargoInsurance + DutyAndTax components in a new public context; if one throws
 * under conditions we couldn't pre-verify (e.g. an unexpected Breeze/SimplyDuty
 * response), the add-ons simply disappear instead of white-screening the whole
 * booking page. The core booking (rate + contact + broker + CTA) is unaffected —
 * add-ons never gate the CTA, so hiding them still lets the visitor book.
 */
import React from 'react';
import PropTypes from 'prop-types';

class AddonsErrorBoundary extends React.Component {
  state = { failed: false };

  static getDerivedStateFromError() {
    return { failed: true };
  }

  componentDidCatch(error, info) {
    // Surface it for debugging without breaking the page.
    console.error('Additional-services add-ons crashed; hiding them.', error, info);
  }

  render() {
    if (this.state.failed) return null;
    return this.props.children;
  }
}

AddonsErrorBoundary.propTypes = {
  children: PropTypes.node,
};

export default AddonsErrorBoundary;
